import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({ providedIn: 'root' })



export class AuthGuard implements CanActivate {


    constructor(
        private router: Router,
        private jwtHelper: JwtHelperService,
        private storageService: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        console.log('AuthGuard checking', state.url);
        const token = this.storageService.getToken();
        const user  = this.storageService.getUser();
        console.log(' token=', token, ' user=', user);
        if (token && !this.jwtHelper.isTokenExpired(token) && user) {
            return true;
        }
        console.log('AuthGuard redirecting to /login');
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}